/**
 * Módulo para gestión de notificaciones
 */

export class Notifications {
    
    /**
     * Configura las notificaciones del formulario
     */
    static setupNotifications() {
        // Verificar si hay un resultado de formulario en ZFM_VARS
        if (typeof ZFM_VARS !== 'undefined' && ZFM_VARS.form_result) {
            const result = ZFM_VARS.form_result;
            this.showNotification(result.message, result.type);
            
            // Limpiar parámetros URL después de mostrar la notificación
            this.cleanUrlParameters();
        }

        // Configurar notificaciones existentes en el DOM (legacy)
        const notification = document.querySelector('.zfm-notification');
        if (!notification) return;
        
        // Botón de cerrar "x"
        const closeBtn = document.createElement('button');
        closeBtn.setAttribute('aria-label', 'Cerrar');
        closeBtn.className = 'zfm-close-btn';
        closeBtn.innerHTML = '×';
        notification.appendChild(closeBtn);

        // Mostrar animación
        setTimeout(() => {
            notification.style.right = '24px';
        }, 100);

        // Cerrar al hacer click en la "x"
        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.hideNotification(notification);
        });

        // Cerrar automáticamente a los 5 segundos
        setTimeout(() => {
            if (notification.style.display !== 'none') {
                this.hideNotification(notification);
            }
        }, 5000);
    }

    /**
     * Limpia los parámetros de notificación de la URL
     */
    static cleanUrlParameters() {
        const url = new URL(window.location);
        const params = url.searchParams;
        
        // Verificar si existen parámetros de notificación
        if (params.has('zfm_result') || params.has('zfm_type') || params.has('zfm_msg')) {
            // Remover parámetros de notificación
            params.delete('zfm_result');
            params.delete('zfm_type');
            params.delete('zfm_msg');
            
            // Actualizar la URL sin recargar la página
            const newUrl = url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;
            window.history.replaceState({}, '', newUrl);
        }
    }

    /**
     * Oculta una notificación
     */
    static hideNotification(notification) {
        notification.style.right = '-400px';
        setTimeout(() => {
            notification.style.display = 'none';
        }, 500);
    }

    /**
     * Limpia todas las notificaciones activas
     */
    static clearNotifications() {
        const existingNotifications = document.querySelectorAll('.zfm-notification');
        existingNotifications.forEach(notif => {
            if (notif.parentNode) {
                notif.parentNode.removeChild(notif);
            }
        });
    }

    /**
     * Muestra una notificación personalizada
     */
    static showNotification(message, type = 'info', duration = 5000) {
        // Remover notificaciones existentes
        this.clearNotifications();

        const notification = document.createElement('div');
        notification.className = `zfm-notification zfm-notif-${type}`;
        
        // Crear contenido con botón de cerrar
        const messageSpan = document.createElement('span');
        messageSpan.innerHTML = message; // Usar innerHTML para permitir HTML en mensajes de debug
        
        const closeBtn = document.createElement('button');
        closeBtn.setAttribute('aria-label', 'Cerrar');
        closeBtn.className = 'zfm-close-btn';
        closeBtn.innerHTML = '×';
        
        notification.appendChild(messageSpan);
        notification.appendChild(closeBtn);
        
        document.body.appendChild(notification);
        
        // Mostrar animación
        setTimeout(() => {
            notification.style.right = '24px';
        }, 100);

        // Cerrar al hacer click en la "x"
        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.hideNotification(notification);
        });

        // Ocultar automáticamente
        setTimeout(() => {
            if (notification.style.display !== 'none') {
                this.hideNotification(notification);
                setTimeout(() => {
                    if (notification.parentNode) {
                        notification.parentNode.removeChild(notification);
                    }
                }, 500);
            }
        }, duration);
    }

    /**
     * Muestra una notificación de éxito
     */
    static showSuccess(message, duration = 5000) {
        this.showNotification(message, 'success', duration);
    }

    /**
     * Muestra una notificación de error
     */
    static showError(message, duration = 8000) {
        this.showNotification(message, 'error', duration);
    }

    /**
     * Muestra una notificación de información
     */
    static showInfo(message, duration = 5000) {
        this.showNotification(message, 'info', duration);
    }
}